import { render, staticRenderFns } from "./PrivacyPolicyVivo.vue?vue&type=template&id=206b3268&scoped=true"
import script from "./PrivacyPolicyVivo.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyVivo.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyVivo.vue?vue&type=style&index=0&id=206b3268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b3268",
  null
  
)

export default component.exports